export type OptionsMapping = Record<number, Record<number, { devices: number, subscription: number }>>

export type ProductsMapping = Map<string, {
  id      : string;
  options?: Promise<OptionsMapping | null>
}>

export type Product = { id: string; devices: number; subscription: number }

export type OptionsSheet = {
  total : number;
  offset: number;
  limit : number;
  data: Array<{
    fromDevices     : number;
    fromSubscription: number;
    toDevices       : number;
    toSubscription  : number;
  }>;
  columns: Array<"fromDevices" | "fromSubscription" | "toDevices" | "toSubscription">;
  ":type": "sheet";
};

export type ProductIdSheet = {
  total : number;
  offset: number;
  limit : number;
  data: Array<{
    from: string;
    to  : string;
  }>;
  columns: Array<"from" | "to">;
  ":type": "sheet";
};

export class Adaptor {
  private mapper: ProductsMapping | null;

  constructor(mapper: ProductsMapping | null) {
    this.mapper = mapper;
  }

  static async create() {
    const productsMapping = await this.getMappings();
    return new Adaptor(productsMapping);
  }

  async adaptTo(param: { id: string }): Promise<{ id: string }>;
  async adaptTo(param: { id: string; devices: number; subscription: number }): Promise<{ id: string; devices: number; subscription: number }>;
  async adaptTo(param: { id: string; devices?: number; subscription?: number }): Promise<{ id: string; devices?: number; subscription?: number }> {
    const { id, devices, subscription } = param;
    const product:{ id: string; devices?: number; subscription?: number } = { id, devices, subscription };

    if (!this.mapper) {
      return product
    }

    const mappedProduct = this.mapper.get(id);

    if (mappedProduct) {
      product.id = mappedProduct.id;
    } else {
      return product;
    }

    if (mappedProduct && !mappedProduct?.options) {
      mappedProduct.options = this.getMappingForId(id);
    }

    if (devices && subscription) {
      const options = await mappedProduct!.options;
      if (options) {
        const option = options[devices]?.[subscription];
        if (option) {
          product.devices = option.devices;
          product.subscription = option.subscription;
        }
      }
    }

    return product;
  }

  static async getMappings() {
    try {
      const response = await fetch("https://www.bitdefender.com/common/store-config/init-to-vlaicu-mappings.json?sheet=id-mappings");
      if (!response.ok) {
        console.error(`${response.status}: ${response.statusText}`);
        return null;
      }

      const sheet:ProductIdSheet = await response.json();
      const products:ProductsMapping = new Map();

      for (const product of sheet.data) {
        const { from, to } = product;

        products.set(from, { id: to })
      }

      return products;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  private async getMappingForId(id: string) {
    try {
      const response = await fetch(`https://www.bitdefender.com/common/store-config/init-to-vlaicu-mappings.json?sheet=${id}`);

      if (!response.ok) {
        console.error(`${response.status}: ${response.statusText}`);
        return null;
      }

      const sheet:OptionsSheet = await response.json();

      const options: OptionsMapping = {};

      for (const option of sheet.data) {
        const
          fromDevices = Number(option.fromDevices),
          fromSubscription = Number(option.fromSubscription),
          toDevices = Number(option.toDevices),
          toSubscription = Number(option.toSubscription)

        if (!options[fromDevices]) {
          options[fromDevices] = {};
        }

        options[fromDevices][fromSubscription] = {
          devices     : toDevices,
          subscription: toSubscription
        }
      }

      return options;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}